import { APP_EED } from '@/features/app-eed/container/app.builder';
import { APPS } from '@/features/core/container';
import { GroupRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import icon from '../assets/app-notification.svg?vue';

export const APP_NOTIFICATION = GroupRole.APP_NOTIFICATION;

export default option(APPS, async () => {
  return {
    name: APP_NOTIFICATION,
    label: 'Benachrichtigung',
    link: {
      to: { name: 'AppNotification' },
      icon,
    },
    hiddenForApps: [APP_EED],
    order: 2,
  };
});
